import { AnchorTagProps } from 'ech-components/src/components/AnchorTag';

const anchorTagService = (data: any) => {
  const anchorTag: AnchorTagProps =
    data && data.anchorTag
      ? {
          anchorTag: data.anchorTag,
        }
      : null;

  return anchorTag;
};

export default anchorTagService;
